import Notifications from 'react-notification-system-redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { getPermissions } from '../../Login/selectors';
import { setLoading } from '../actions';
import { loadSettings, updateKey } from '../actionsSagas';
import { getLoading, getSettings } from '../selectors';
import Settings from './Settings';

const mapStateToProps = (state) => ({
  settings: getSettings(state),
  loading: getLoading(state),
  permissions: getPermissions(state),
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => {
    dispatch(setLoading(true));
    dispatch(loadSettings());
  },
  updateKey: (key) => {
    dispatch(updateKey(key));
  },
  showWarning: (title, message) =>
    dispatch(Notifications.warning({ title, message }, 'failure')),
});

const connected = connect(mapStateToProps, mapDispatchToProps)(Settings);

const SettingsContainer = reduxForm({
  form: 'settings',
})(connected);

export default SettingsContainer;
